var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.rxData
    ? _c("div", { staticClass: "prescription-detail" }, [
        _c(
          "div",
          { staticClass: "prescription-status", class: _vm.getStatusClass() },
          [
            _c(
              "div",
              { staticClass: "status-content" },
              [
                _c("van-icon", {
                  attrs: {
                    name: _vm.getStatusIcon(),
                    color: "#fff",
                    size: "28",
                  },
                }),
                _c("span", { staticClass: "status-text" }, [
                  _vm._v(_vm._s(_vm.getStatusText())),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "validity" }, [
              _vm._v(" " + _vm._s(_vm.rxData.dealDesc) + " "),
            ]),
          ]
        ),
        _c("div", { staticClass: "hospital-info" }, [
          _c("div", { staticClass: "hospital-name" }, [
            _vm._v(_vm._s(_vm.rxData.clinicName)),
          ]),
          _c("div", { staticClass: "prescription-type" }, [
            _vm._v(_vm._s(_vm.rxData.deptName)),
          ]),
        ]),
        _c("div", { staticClass: "prescription-content" }, [
          _c("div", { staticClass: "prescription-title" }, [
            _vm._v("电子处方笺"),
          ]),
          _c("div", { staticClass: "info-section patient-info" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("患者信息：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.rxData.patientInfo.name)),
              ]),
              _c("span", { staticClass: "gender" }, [
                _vm._v(_vm._s(_vm.rxData.patientInfo.sex === 1 ? "男" : "女")),
              ]),
              _c("span", { staticClass: "age" }, [
                _vm._v(
                  _vm._s(_vm.calculateAge(_vm.rxData.patientInfo.birthdate)) +
                    "岁"
                ),
              ]),
            ]),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("就诊科室：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.rxData.deptName)),
              ]),
            ]),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("开方时间：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.rxData.rxCreateTime)),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "info-item" },
              [
                _c("span", { staticClass: "label" }, [_vm._v("处方号：")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.rxData.rxNo)),
                ]),
                _c("van-icon", {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value: _vm.rxData.rxNo,
                      expression: "rxData.rxNo",
                      arg: "copy",
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:success",
                      value: () => _vm.$toast("复制成功"),
                      expression: "() => $toast('复制成功')",
                      arg: "success",
                    },
                  ],
                  attrs: { name: "description", color: "#1989fa" },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "info-section diagnosis" }, [
            _c("div", { staticClass: "section-title" }, [_vm._v("临床诊断")]),
            _c(
              "div",
              { staticClass: "diagnosis-content" },
              _vm._l(_vm.rxData.diseaseInfos, function (disease, index) {
                return _c("div", { key: index }, [
                  _vm._v(" " + _vm._s(disease.diseaseName) + " "),
                ])
              }),
              0
            ),
          ]),
          _c(
            "div",
            { staticClass: "info-section medicine-info" },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("处方药品")]),
              _vm._l(_vm.rxData.drugsInfos, function (drug, index) {
                return _c("div", { key: index, staticClass: "medicine-item" }, [
                  _c("div", { staticClass: "medicine-name" }, [
                    _vm._v(_vm._s(drug.comName)),
                  ]),
                  _c("div", { staticClass: "medicine-spec" }, [
                    _vm._v(
                      _vm._s(drug.spec) +
                        " x" +
                        _vm._s(drug.count) +
                        _vm._s(drug.countUnit)
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "medicine-usage" },
                    [
                      _c("van-icon", { attrs: { name: "clock-o" } }),
                      _c("span", [
                        _vm._v(
                          _vm._s(drug.usage) +
                            "，" +
                            _vm._s(drug.frequency) +
                            "，" +
                            _vm._s(drug.instructions) +
                            "，" +
                            _vm._s(drug.days)
                        ),
                      ]),
                    ],
                    1
                  ),
                ])
              }),
            ],
            2
          ),
          _c("div", { staticClass: "info-section doctor-info" }, [
            _c("div", { staticClass: "doctor" }, [
              _c("span", { staticClass: "label" }, [_vm._v("医师：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.rxData.doctorName)),
              ]),
            ]),
            _c("div", { staticClass: "checker" }, [
              _c("span", { staticClass: "label" }, [_vm._v("审核：")]),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.rxData.pharmacistName)),
              ]),
            ]),
          ]),
        ]),
        false
          ? _c(
              "div",
              { staticClass: "bottom-buttons" },
              [
                _c(
                  "van-button",
                  {
                    staticClass: "cart-btn",
                    attrs: { plain: "", type: "primary" },
                    on: { click: _vm.goToCart },
                  },
                  [_vm._v("加入购物车")]
                ),
                _c(
                  "van-button",
                  {
                    staticClass: "buy-btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.buyNow },
                  },
                  [_vm._v("立即购买")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.rxData.rxId && _vm.rxData.status === "1"
          ? _c("div", { staticClass: "rx-btn", on: { click: _vm.preview } }, [
              _vm._v("处方"),
              _c("br"),
              _vm._v("图片"),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }